
          import { mount } from 'svelte';
          import Module from './wwwroot/js/module/identity/Login.svelte';

          const target = document.getElementById('module-container');
          const props = target.dataset.props ? JSON.parse(target.dataset.props) : {};
                    
          mount(Module, {
            target: target,
            props: props
          });